import react from "react";
import "./ITCBox.css";
import { useLocation } from "react-router-dom";
export default function ILTCBox({ Head, Title, TitleWidth, TitleWidthMob, Para, ParaS, ParaWidth, ImgSrc, ImgAlt, TextAlign, ImgOrder }) {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div className="ILTCBox">
        <div className={`ILTCBoxText TFut24PxPC ${isArabic ? "arabic" : "english"}`}>
          {/* <div className={`ILTCBHead TFut24PxPC ${isArabic ? "arabic" : "english"}`} style={{ textAlign: TextAlign }}>
            {Head}
          </div> */}
          <div
            className={`ILTCBTitle TGLo48PxPC ${isArabic ? "arabic" : "english"}`}
            style={{ width: isMobile ? TitleWidthMob : TitleWidth, textAlign: TextAlign }}
          >
            {Title}
          </div>
          <div
            className={`ILTCBPara TFut20PxPC ${isArabic ? "arabic" : "english"}`}
            style={{ width: ParaWidth, textAlign: TextAlign }}
            dir={isArabic ? "rtl" : ""}
          >
            {Para}
          </div>
          {ParaS && (
            <div className={`ILTCBPara TFut20PxPC ${isArabic ? "arabic" : "english"}`} style={{ width: ParaWidth, textAlign: TextAlign }}>
              {ParaS}
            </div>
          )}
        </div>
        <div className="ILTCBoxImg" style={{ order: isMobile ? ImgOrder : "" }}>
          <img src={ImgSrc} alt={ImgAlt} />
        </div>
      </div>
    </>
  );
}
